export enum CountryCodes {
  CANADA = 'CA',
  USA = 'US',
}
